<template>
    <section class="section section-shaped section-lg my-0">
        <div class="shape shape-style-1 bg-gradient-default">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div class="container pt-lg-md">
            <div class="row justify-content-center">
              <!-- Content Start -->
              <div class="col-lg-8 col-md-10 mx-auto">
                <h1 class="post-heading">Clubhouse in Japan: catching fire like flash paper</h1>
                <h2 class="subheading">(and fizzling out equally quickly)</h2>
                <span class="meta"> Posted in April 2021 </span>

                <p class="author-info ">Mark Bivens is a Silicon Valley native and former entrepreneur, having started three companies before becoming a VC. He is the Managing Partner of Shizen Capital (formerly known as Tachi.ai Ventures) in Japan. You can read more on his blog at <a href="http://markbivens.com">http://rude.vc</a> or follow him on Twitter <a href="https://twitter.com/markbivens">@markbivens</a>.</p>

                <figure>
                  <img class="img-fluid" src="img/blog/card/clubhouse-japan.jpg" alt="">
                </figure>
                
                <p>We were having an interesting discussion yesterday about the rise and fall of Clubhouse in Japan. I was fortunate to be enlightened by a couple individuals who are much more in tune with the phenomenon here.</p>

                <p>In late January Clubhouse launched in Japan and quickly shot up to first among free apps on the Apple App Store. Politicians even started <a href="https://asia.nikkei.com/Business/Technology/Japan-lawmakers-join-Clubhouse-app-to-reach-voters">using it</a>. </p>

                <p>Barely two months later, Clubhouse has turned into a manifestation of that old Yogi Berra quip: “Nobody goes there anymore; it’s too crowded.”</p>


                <h2 class="section-heading">Why did Clubhouse catch fire in Japan ?</h2>
                
                <p>In many ways, Japan is an ideal the ideal market for Clubhouse. Everyone possesses a smartphone connected to reliable 4G, (5G now in many places) networks, even on the high-speed trains and underground metros. Of course the partial re-balancing to work-from-home during the pandemic provided a convenient opportunity to escape to Clubhouse. Yet since Covid-19 has presented more of an inconvenience then mass devastation in Japan, many people still worked in the office. For those individuals, a combination of long commutes and or the taboo of leaving the office before the boss leaves provides ample opportunities to kill time. </p>
                
                <p>Moreover, the exclusive appeal of Clubhouse plays well with the Japanese consumer. Just like walking around Tokyo with a shopping bag from Trader Joe’s subtly signals that you’ve flown to the U.S. recently, joining a perceived-to-be prestigious, invite-only smart phone app from Silicon Valley — and then announcing it on social media — generates serious FOMO here.</p>


                <h2 class="section-heading">Then why is it fizzling out ?</h2>

                <p>The primary medium for Clubhouse FOMO in Japan was Facebook — Twitter to as well to some extent but not, notably, LinkedIn. Professionals in Japan use Facebook way more than LinkedIn. For salaried employees, freelancers, entrepreneurs, and investors, Facebook serves as the primary social network for not only friendships but also for professional connections. There are 26 million monthly active users on Facebook here.  Numerous people have told me that I am the only VC in Japan who is not on Facebook (probably to my detriment, but sorry even I draw some lines in the sand).</p>

                <p>In contrast, despite entering Japan nearly 10 years ago, LinkedIn only counts a couple million active users to this day in Japan. Although the network is gaining in popularity among the professional class, for a long time there was a signaling associated with creating an account on LinkedIn in Japan. If you were gainfully employed, creating a profile on LinkedIn implied that you might be looking for other job opportunities, a potentially career-limiting move in large Japanese corporations where loyalty and lifetime employment are prized.</p>

                <p>The problem with Facebook (well, one problem) is its abundance of junk. So Clubhouse has become somewhat a victim of its own success in Japan. Because Clubhouse memberships spread primarily through Facebook, anyone could join, and everyone did, including peddling of all sorts of thought-leadership babble.</p>

                <p>I witnessed this same phenomenon play out in France, encapsulated tersely in a wonderfully cheeky tweet by Cédric Giorgi:</p>

                <p><blockquote class="twitter-tweet"><p lang="fr" dir="ltr">J&#39;adore Clubhouse, vraiment je suis fan de ce nouveau réseau et des conversations et échanges qui y ont lieu. Mais c&#39;est en train de devenir le royaume des infopreneurs, des vendeurs de pioche, des business coachs and co. et c&#39;est beaucoup trop tôt pour ça !</p>&mdash; Cédric Giorgi (@cgiorgi) <a href="https://twitter.com/cgiorgi/status/1361330196599693314?ref_src=twsrc%5Etfw">February 15, 2021</a></blockquote></p>

                <p>However it seemed to take several months before French Clubhouse became overrun by the "vendeurs de pioche." In Japan it only took three weeks.</p>

              </div>
            </div>
        </div>
    </section>
</template>
<script>
export default {};
</script>
<style>
.post-heading,
.subheading,
.section-heading,
.blockquote,
.meta,
p,
span {
  color: #fff;
}
.post-heading {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
}
.subheading {
  font-size: 20px;
  margin-top: 16px;
}
.section-heading {
  font-weight: 700;
  margin-top: 32px;
}
.section-heading + p {
  margin-top: 16px;
}
.meta + p {
  margin-top: 32px;
}
.author-info {
  font-size: 14px;
  font-style: italic;
  line-height: 1.5;
}
figure {
  margin-top: 24px;
}
</style>
